
(() => {
  if (window.stilBuyNowReady) return;
  window.stilBuyNowReady = true;

  document.addEventListener("click", async (event) => {
    const btn = event.target.closest(
      ".sm-buy-now[data-variant-id]"
    );

    if (!btn || btn.disabled) return;

    event.preventDefault();
    event.stopPropagation();

    const label = btn.querySelector(".sm-buy-now__label");
    const original = label.textContent;

    btn.disabled = true;
    label.textContent = "SE PROCESEAZĂ...";

    const root = window.Shopify?.routes?.root || "/";

    try {
      const response = await fetch(root + "cart/add.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          items: [{
            id: Number(btn.dataset.variantId),
            quantity: 1
          }]
        })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data.description || "Produsul nu a putut fi adăugat."
        );
      }

      window.location.assign("/checkout");

    } catch (error) {
      alert(error.message || "A apărut o eroare.");
      btn.disabled = false;
      label.textContent = original;
    }
  });
})();
